import { FiChevronRight } from 'react-icons/fi';
import { IoMdCheckmarkCircle } from 'react-icons/io';
import { useMediaQuery } from 'react-responsive';

type Props = {
  onClick: () => void;
  elementsCount: number;
};

const GroupOrderCTA = ({ onClick, elementsCount }: Props) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <div
      className='t-my-5 t-flex t-cursor-pointer t-items-center t-justify-between t-gap-2 t-overflow-hidden t-rounded-xl t-border t-border-neutrals-light-grey t-px-4 t-py-3 t-transition t-duration-200 hover:t-bg-neutral-100 [&_*]:t-cursor-pointer'
      onClick={onClick}>
      <div className='t-w-[calc(100%-42px)] t-pl-1'>
        <p className='t-mb-0 t-text-xs t-font-bold t-leading-5 t-text-brand-black md:t-text-base'>
          {elementsCount >= 1 ? (
            <span className='t-inline-flex t-items-center t-gap-1'>
              <IoMdCheckmarkCircle size={isMobile ? 20 : 24} color='var(--plum-primary-color)' />
              <span>
                {elementsCount} {elementsCount === 1 ? <>Name</> : <>Names</>} Added
              </span>
            </span>
          ) : (
            <>Ordering for a group?</>
          )}
        </p>

        <p className='t-mb-0 t-text-xs t-font-normal t-leading-3 t-text-neutrals-dark-grey md:t-text-sm md:t-leading-4'>
          Make each item unique with its own name, title, and/or number.
        </p>
      </div>

      <div className='t-flex t-h-[36px] t-w-[36px] t-items-center t-justify-end'>
        <FiChevronRight size={24} className='t-text-brand-black' />
      </div>
    </div>
  );
};

export default GroupOrderCTA;
